import { render, staticRenderFns } from "./NeoBigTitle.vue?vue&type=template&id=e5505610&scoped=true&"
import script from "./NeoBigTitle.vue?vue&type=script&lang=js&"
export * from "./NeoBigTitle.vue?vue&type=script&lang=js&"
import style0 from "./NeoBigTitle.vue?vue&type=style&index=0&id=e5505610&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5505610",
  null
  
)

export default component.exports